module.exports = __webpack_public_path__ + "img/HYPRControlCenter_Hero.76367cb2.jpg";